export const ORDER_HISTORY = [
  {
    order_number: 'M12545',
    status: 'Processing',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  },
  {
    order_number: 'M12545',
    status: 'Processing',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  },
  {
    order_number: 'M12545',
    status: 'Processing',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  },
  {
    order_number: 'M12545',
    status: 'Processing',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  },
  {
    order_number: 'M12545',
    status: 'Processing',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  },
  {
    order_number: 'M12545',
    status: 'Processing',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  }
]

export const DRAFT_ORDER_HISTORY = [
  {
    draft_number: 'M12545',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  },
  {
    draft_number: 'M12545',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  },
  {
    draft_number: 'M12545',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  },
  {
    draft_number: 'M12545',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  },
  {
    draft_number: 'M12545',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    bill_to: 'Slacker HQ 1122 Smith Rd.',
    ship_to: 'Houston Location 3223 Alscot Ave #45',
    buyer: 'Joe Shlack',
    total: '$5,560.25',
    action: ''
  }
]

export const INVOICE_HISTORY = [
  {
    invoice_number: 'M12545',
    status: 'Open',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    due_date: '10/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    total_shipped: '$12,234.54',
    balance: '$5,560.25',
    action: ''
  },
  {
    invoice_number: 'M12545',
    status: 'Open',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    due_date: '10/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    total_shipped: '$12,234.54',
    balance: '$5,560.25',
    action: ''
  },
  {
    invoice_number: 'M12545',
    status: 'Open',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    due_date: '10/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    total_shipped: '$12,234.54',
    balance: '$5,560.25',
    action: ''
  },
  {
    invoice_number: 'M12545',
    status: 'Open',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    due_date: '10/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    total_shipped: '$12,234.54',
    balance: '$5,560.25',
    action: ''
  },
  {
    invoice_number: 'M12545',
    status: 'Open',
    company: "Joe's Over Rated Competer Store",
    order_date: '1/22/22',
    ship_date: '8/25/22',
    due_date: '10/25/22',
    po_number: 'TL223454',
    ref_note: 'SS21 Pre- Selection',
    total_shipped: '$12,234.54',
    balance: '$5,560.25',
    action: ''
  }
]

export const FILTER_TAB = [
  {
    id: 1,
    name: 'company',
    expanded: false,
    checkedCount: 0
  },
  {
    id: 2,
    name: 'status',
    expanded: false,
    checkedCount: 0
  },
  {
    id: 3,
    name: 'order date range',
    expanded: false,
    checkedCount: 0
  },
  {
    id: 4,
    name: 'buyer',
    expanded: false,
    checkedCount: 0
  },
  {
    id: 5,
    name: 'start ship range',
    expanded: false,
    checkedCount: 0
  },
  {
    id: 6,
    name: 'location',
    expanded: false,
    checkedCount: 0
  }
]
